import { ElementRef, Injectable } from '@angular/core';
import { CalendarDateFirstService } from '../../../services/calendar/date-first/calendar-date-first.service';

@Injectable({
    providedIn: 'root',
})
export class DatePickService {
    private initialFocusPending: boolean = false;

    constructor(private calendarDateFirstService: CalendarDateFirstService) {}

    requestInitialFocus(): void {
        this.initialFocusPending = true;
    }

    cancelInitialFocus(): void {
        this.initialFocusPending = false;
    }

    setInitialFocus(): void {
        if (!this.initialFocusPending) {
            return;
        }

        this.initialFocusPending = false;

        // Die Zeiten kommen asynchron, der Fokus kann inzwischen der Nutzerin gehören.
        if (!this.mayTakeFocus()) {
            return;
        }

        this.calendarDateFirstService.focusFirstSelectableDay();
    }

    setInitialTimeFocus(firstElementRef?: ElementRef): void {
        if (!this.mayTakeFocus()) {
            return;
        }

        firstElementRef?.nativeElement?.focus();
    }

    private mayTakeFocus(): boolean {
        const active = this.activeElement();

        return !active || active === document.body;
    }

    private activeElement(root: DocumentOrShadowRoot = document): Element | null {
        const active = root.activeElement;

        return active?.shadowRoot ? this.activeElement(active.shadowRoot) : active;
    }
}
